import React, { useEffect, useState } from 'react'
import { Link, useParams } from 'react-router-dom'
import blogServices from '../../services/BlogService'
import { Helmet, HelmetProvider } from 'react-helmet-async'
import Loading from '../../components/feedback/Loading'
import FetchError from '../../components/feedback/FetchError'
import utils from '../../utils'
import moment from 'moment'
import { LuChevronRight } from 'react-icons/lu'

function BlogViewPage() {
    const [post, setPost] = useState()
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState()
    const postParam = useParams()

    useEffect(() => {
        setError()
        blogServices.getSpecificBlog(postParam?.slug).then(
            res => {
                setPost(res.data)
                setLoading(false)
            },
            err => {
                console.log(err);
                setError(err)
                setLoading(false)
            }
        )
    }, [postParam?.slug])
    useEffect(() => { }, [error])
    useEffect(() => { }, [post])
    return (
        <HelmetProvider>
            <div className=''>
                {loading ? (<Loading />) : (
                    <div>
                        {error ? (<FetchError error={error} />) : (
                            <div>
                                <Helmet>
                                    <title>{post?.name} - {utils.siteName}</title>
                                </Helmet>
                                <section className="relative h-[614px] min-h-[400px] w-full flex items-end overflow-hidden">
                                    <img
                                        className="absolute inset-0 w-full h-full object-center object-cover"
                                        src={utils.baseUrl + post.image}
                                        alt={post.name}
                                    />
                                    <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/40 to-transparent"></div>

                                    <div className="relative w-full container mx-auto px-3 pb-16 z-10">
                                        <nav className="flex items-center gap-2 text-sm font-bold uppercase tracking-widest mb-6">
                                            <Link className="text-white/80 transition-all" to="/">Home</Link>
                                            <LuChevronRight size={14} className="text-white/40" />
                                            <Link className="text-white/80 transition-all" to="/blog">Blog</Link>
                                            <LuChevronRight size={14} className="text-white/40" />
                                            <span className="text-white/80 truncate max-w-[200px] md:max-w-none">
                                                {post.name}
                                            </span>
                                        </nav>

                                        <div className="flex flex-col gap-4">
                                            <span className="text-white/70 font-black text-xs uppercase tracking-[0.3em]">
                                                {moment(post.creation_time).format("MMMM Do, YYYY")}
                                            </span>
                                            <h1 className="text-4xl md:text-6xl font-headline font-black text-white max-w-4xl tracking-tighter leading-tight">
                                                {post.name}
                                            </h1>
                                        </div>
                                    </div>
                                </section>

                                <section className="container mx-auto px-3  pb-16">
                                    <div className="bg-white rounded-3xl shadow-[0_40px_80px_-20px_rgba(0,0,0,0.08)] overflow-hidden border border-outline-variant/10">

                                        <div className="p-8 md:p-16">
                                            <article className="prose prose-lg max-w-none prose-headings:font-headline prose-headings:font-black prose-headings:tracking-tight prose-p:text-on-surface-variant prose-p:leading-relaxed prose-strong:text-on-surface prose-img:rounded-2xl mb-16">
                                                <div dangerouslySetInnerHTML={{ __html: post?.text }} />
                                            </article>

                                            <hr />

                                            <div className="mt-16 pt-8 border-t border-outline-variant/10 flex flex-col md:flex-row justify-between items-center gap-6">
                                                <div className="flex items-center gap-4">
                                                    <div className="w-12 h-12 bg-primary rounded-full flex items-center justify-center text-white font-black">
                                                        {post?.owner?.email?.charAt(0).toUpperCase()}
                                                    </div>
                                                    <div>
                                                        <p className="text-[10px] font-black uppercase tracking-widest text-on-surface-variant">Author</p>
                                                        <p className="font-bold text-on-surface">{'Jahtech Consultant'}</p>
                                                    </div>
                                                </div>

                                                <button
                                                    onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                                                    className="px-6 py-3 bg-surface-container-low text-primary font-black text-xs uppercase tracking-widest rounded-xl hover:bg-primary hover:text-white transition-all"
                                                >
                                                    Back to Top
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </section>

                            </div>
                        )}
                    </div>
                )}
            </div>
        </HelmetProvider>
    )
}

export default BlogViewPage